export enum PlatformBillingContractStateEnum {
    READY = 'ready',
    INCOMPLETE = 'incomplete',
}
